import React from 'react';
import { css } from 'styled-system/css';

import { Field } from '@shaojiang/components/ui/field';

type Props = {
  label?: string;
  error?: string;
  helperText?: string;
  multiline?: boolean;
  rows?: number;
  className?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
    ref?: React.Ref<HTMLInputElement>;
  };

/** Filled-style text field built on the Park UI Field. Works with react-hook-form's `register`. */
export const filledInput = css({
  bg: 'gray.a2',
  borderColor: 'transparent',
  _dark: { bg: 'gray.a3' },
  _focus: { bg: 'bg.default' },
});

export default function TextField({
  label,
  error,
  helperText,
  multiline,
  rows,
  className,
  ref,
  ...inputProps
}: Props) {
  return (
    <Field.Root invalid={!!error} className={className ?? css({ my: '2' })}>
      {label && <Field.Label>{label}</Field.Label>}
      {multiline ? (
        <Field.Textarea
          rows={rows}
          className={filledInput}
          {...(inputProps as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
          ref={ref as unknown as React.Ref<HTMLTextAreaElement>}
        />
      ) : (
        <Field.Input className={filledInput} {...inputProps} ref={ref} />
      )}
      {error ? (
        <Field.ErrorText>{error}</Field.ErrorText>
      ) : (
        helperText && <Field.HelperText>{helperText}</Field.HelperText>
      )}
    </Field.Root>
  );
}
